import React, { useEffect, useState } from "react";
import { Pie } from "react-chartjs-2";
import axios from "axios";
import "./CitizenImpactRightSidebar.css";
import Chart from "chart.js/auto";

/* ==========================
   Attractive Color Palette
========================== */

const GENDER_COLORS = ["#FFB3C7", "#BDB2FF", "#A0C4FF"];

const AGE_COLORS = [
  "#FFC8DD",
  "#FFAFCC",
  "#BDE0FE",
  "#A2D2FF",
  "#CDB4DB",
  "#B9FBC0",
  "#FFDDD2"
];

const CitizenImpactRightSidebar = ({
  selectedGender,
  selectedAgeRange,
  selectedState,
  selectedDistrict,
  selectedProjectName
}) => {

  const [genderData, setGenderData] = useState(null);
  const [ageData, setAgeData] = useState(null);

  /* ==========================
     Chart Styling Options
  ========================== */

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,

    animation: {
      duration: 1200,
      easing: "easeInOutQuart"
    },

    plugins: {
      tooltip: {
        backgroundColor: "#333",
        titleFont: { size: 13 },
        bodyFont: { size: 12 },

        callbacks: {
          label: function (context) {
            const value = Number(context.raw) || 0;

            const total = context.dataset.data.reduce(
              (acc, val) => acc + Number(val),
              0
            );

            const percentage = total
              ? ((value / total) * 100).toFixed(1)
              : 0;

            return `${context.label}: ${value.toLocaleString(
              "en-IN"
            )} (${percentage}%)`;
          }
        }
      },

      legend: {
        position: "bottom",
        labels: {
          padding: 16,
          usePointStyle: true,
          font: {
            size: 12
          }
        }
      }
    }
  };

  /* ==========================
     Fetch Sidebar Data
  ========================== */

  const fetchSidebarData = async () => {
    try {
      const res = await axios.post(
        "https://api-sales-insights.haqdarshak.com/api/citizen-impact/sidebar-data",
        {
          gender: selectedGender || [],
          ageRange: selectedAgeRange || [],
          state: selectedState || [],
          district: selectedDistrict || [],
          projectName: selectedProjectName || []
        }
      );

      const data = res.data || [];

      /* ---------- Gender Aggregation ---------- */

      const genderCount = {
        Male: 0,
        Female: 0,
        Others: 0
      };

      data.forEach((item) => {
        const count = Number(item.totalCount) || 0;

        if (item.CitizenGender === "M")
          genderCount.Male += count;
        else if (item.CitizenGender === "F")
          genderCount.Female += count;
        else
          genderCount.Others += count;
      });

      /* ---------- Dynamic Age Aggregation ---------- */

      const ageCount = {};

      data.forEach((item) => {
        const range = item.Age_Range || "Unknown";
        const count = Number(item.totalCount) || 0;

        if (!ageCount[range]) ageCount[range] = 0;
        ageCount[range] += count;
      });

      const ageLabels = Object.keys(ageCount);
      const ageValues = Object.values(ageCount);

      /* ---------- Set Gender Chart ---------- */

      setGenderData({
        labels: ["Male", "Female", "Others"],
        datasets: [
          {
            data: [
              genderCount.Male,
              genderCount.Female,
              genderCount.Others
            ],

            backgroundColor: GENDER_COLORS,
            borderWidth: 2,
            borderColor: "#ffffff",
            hoverOffset: 18
          }
        ]
      });

      /* ---------- Set Age Chart ---------- */

      setAgeData({
        labels: ageLabels,
        datasets: [
          {
            data: ageValues,

            backgroundColor: AGE_COLORS.slice(
              0,
              ageLabels.length
            ),

            borderWidth: 2,
            borderColor: "#ffffff",
            hoverOffset: 18
          }
        ]
      });

    } catch (err) {
      console.error("Sidebar fetch error:", err);
    }
  };

  /* ==========================
     Refetch on Filter Change
  ========================== */

  useEffect(() => {
    fetchSidebarData();
  }, [
    selectedGender,
    selectedAgeRange,
    selectedState,
    selectedDistrict,
    selectedProjectName
  ]);

  return (
    <div className="citizen-impact-rightsidebar">
      <div className="citizen-impact-content">

        <h4 className="sidebar-chart-title">Gender Distribution</h4>

        <div style={{ height: "220px" }}>
          {genderData ? (
            <Pie data={genderData} options={chartOptions} />
          ) : (
            <p>Loading...</p>
          )}
        </div>

        <h4 className="sidebar-chart-title" style={{ marginTop: "28px" }}>
          Age Range Distribution
        </h4>

        <div style={{ height: "260px" }}>
          {ageData ? (
            <Pie data={ageData} options={chartOptions} />
          ) : (
            <p>Loading...</p>
          )}
        </div>

      </div>
    </div>
  );
};

export default CitizenImpactRightSidebar;